import { loginByMobile, getVerificationCode, loginAndSendCoupon, queryActStatus } from '@/api/user';
import { gainCoupon } from '@/api/coupon';
import { queryActivityDetail , queryRule } from '@/api/activity'

function login(mobile: string, code: string, id: string) {
  return new Promise((resolve, reject) => {
    let data: object = {
      country: 'CN',
      mobile: mobile,
      code: code,
      appPushId: '',
      regChannel: 31
    }
    loginByMobile(data).then((res: any) => {
      sessionStorage.setItem('token', res.token);
      sessionStorage.setItem('userInfo', JSON.stringify(res));
      gainCouponFn(id).then((val: any) => {
        resolve(val)
      })
    })
  })
}

// 登录并领取
function hwloginAndSendCoupon(areCode: string, phone: string, verifyCode: string) {
  return new Promise((resolve, reject) => {
    let data: object = {
      areCode: areCode,
      phone: phone,
      verifyCode: verifyCode
    }
    loginAndSendCoupon(data).then((res: any) => {
      resolve(res)
    }).catch((err)=>{
      reject(err)
    })
  })
}

function gainCouponFn(activityId: string) {
  return new Promise((resolve) => {
    let data = {
      activityId: activityId,
      country: 'CN'
    }
    gainCoupon(data).then((res: any) => {
      resolve(res)
    })
  })
}

function getActivity(id: string) {
  return new Promise((resolve, reject) => {
    let data = {
      activityId: id
    }
    queryActivityDetail(data).then((res: any) => {
      resolve(res)
    }) 
  })
}
function getCode(params: object) {
  return new Promise((resolve) => {
    getVerificationCode(params).then((res: any) => {
      resolve(res)
    })
  })
}

function queryRuleFn(activityId: string) {
  return new Promise((resolve) => {
    let data = {
      activityId: activityId
    }
    queryRule(data).then((res: any) => {
      resolve(res)
    })
  })
}
function goToPage(type: string, country: string, language: string) {
  // let href = 'https://superapp-global.superhi-tech.com/pos-privacy-policy/#/';
  let href = 'https://tos.superhi-tech.com/#/';
  // if (window?.location?.href?.includes('hdltest.com')) {
  //   href = ' https://tos.testsuperhi.com/#/';
  // }
  if (language.includes('HK-TW') ) {
    language = 'EN'
  }
  let url = '';
  if (type === 'user') {
    url = `${href}memberNoticeNewHw?country=${country}&language=${language}`
  } else if (type === 'privacy') {
    url = `${href}privacyPolicyNewHw?country=${country}&language=${language}`
  }
  window.location.href = url;
}
// (1:未开始 2:进行中 3:已停止 4:已结束 5:已作废 )
function filterStatus(status: string | number) {
  let text = '';
  switch (Number(status)) {
    case 1:
      text = "未开始";
      break;
    case 2:
      text = "进行中";
      break;
    case 3:
      text = "已结束";
      break;
  }
  return text;
}
// 获取活动状态
function h5queryActStatus () {
  return new Promise((resolve, reject) => {
    queryActStatus({}).then((res: any) => {
      resolve(res)
    }).catch(err=>{
      reject(err)
    })
  })
}

const LOGIN_EMAIL = 'email';
// 先有得翻译，后有的登录方式
const LOGIN_PHONE = 'phone_number';

const loginTypeList = [
  {
    value: LOGIN_EMAIL
  },
  {
    value: LOGIN_PHONE
  }
];

export {
  getActivity,
  gainCouponFn,
  login,
  hwloginAndSendCoupon,
  getCode,
  goToPage,
  filterStatus,
  queryRuleFn,
  h5queryActStatus,
  loginTypeList,
  LOGIN_EMAIL,
  LOGIN_PHONE,
}